import { variables } from '@indriver/yrel';

var preset = {
  labelColor: variables['text-and-icon-primary'],
  colorDisabled: variables['text-and-icon-disabled'],
  hintColorInvalid: variables['extensions-text-and-icon-error'],
  hintColorInfo: variables['text-and-icon-secondary'],
  fontFamily: variables['font-family-noto']
};

export { preset as default };
